/**
 * better-auth React/browser client — Commerco Wave 7 (W7-1).
 *
 * Exposes the typed `signIn` / `signUp` / `signOut` / `useSession` hooks the
 * `(auth)/sign-in/page.tsx` and the workspace selector chip consume.
 *
 * Defensive design: this file is the ONLY place where the better-auth
 * browser-side baseURL gets resolved. Components import `authClient` from
 * here so the cookie host stays in lockstep with the server `auth` instance.
 */
import { createAuthClient } from "better-auth/react";

function resolveBaseUrl(): string {
  if (typeof window !== "undefined") {
    // Same-origin XHR — server and client share the host.
    return window.location.origin;
  }
  return (
    process.env["NEXT_PUBLIC_APP_URL"] ??
    process.env["BETTER_AUTH_URL"] ??
    "http://localhost:3000"
  );
}

export const authClient = createAuthClient({
  baseURL: resolveBaseUrl(),
});

export const { signIn, signUp, signOut, useSession } = authClient;
